import styled, { css } from "styled-components";

export const StyledWhy = styled.div`
    background: ${p => p.theme.c.white};
    clip-path: polygon(0 0, 55% 0, 100% 56px, 100% 100%, 0 100%);
    position: relative;
    padding-top: 130px;
    padding-bottom: 24px;
    margin-top: -300px;
    background-color: ${p => p.theme.c.light};
    background-size: cover;
    background-attachment: fixed;
    background-position: center;
    h2 {
        font-size: 38px;
        text-transform: uppercase;
        text-align: center;
        ${p =>
            p.theme.lg(css`
                padding: 0 160px;
            `)}

        ${p =>
            p.theme.md.only(css`
                font-size: 32px;
                padding: 0 64px;
            `)}

        ${p =>
            p.theme.sm.max(css`
                font-size: 30px;
                margin-bottom: 10px;
                padding: 0 32px;
            `)}
        
         ${p =>
             p.theme.xs(css`
                 padding: 0 16px;
             `)}
    }


    display: flex;
    flex-direction: column;
    font-size: 24px;
    font-weight: 300;
    color: ${p => p.theme.c.boost};

    ${p =>
        p.theme.md.only(css`
            margin-top: -278px;
        `)}

    ${p =>
        p.theme.sm.max(css`
            padding-bottom: 12px;
            margin-top: -290px;
            padding-top: 140px;
        `)}

    ${p =>
        p.theme.xs(css`
            clip-path: none;
            margin-top: -80px;
            padding-top: 56px;
        `)}

`;

export const P = styled.p`
    margin: auto;
    padding: 0 0 12px;
    line-height: 1.5;
    text-align: justify;
    color: ${p => p.theme.c.dark};
    ${p =>
        p.theme.md.min(css`
            width: 850px;
        `)}

    ${p =>
        p.theme.sm.max(css`
            padding: 0 16px;
            font-size: 18px;
            text-align: justify;
        `)}
    ${p =>
        p.theme.sm.only(css`
            padding: 0 32px;
        `)}
    ${p =>
        p.theme.md.only(css`
            font-size: 20px;
        `)}

    ${p =>
        p.theme.xs(css`
            br {
                display: none;
            }
            hyphens: manual;
        `)}

`;

export const Row = styled.div`
    display: flex;
    padding: 0 120px;
    margin-top: 32px;

    ${p =>
        p.theme.md.only(css`
            padding: 0 60px;
        `)}

    ${p =>
        p.theme.sm.only(css`
            padding: 0 32px;
        `)}

    ${p =>
        p.theme.xs(css`
            padding: 0;
            flex-direction: column;
        `)}
`;

export const Column = styled.div`
    flex: 1;
    margin-bottom: 16px;
`;

export const IconWrapper = styled.div`
    width: 72px;
    height: 72px;
    margin: auto;
    border-radius: 36px;
    border: solid 4px ${p => p.theme.c.boost};
    background-color: ${p => p.theme.c.active};
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;

    [class^="i-"] {
        font-size: 42px;
        color: ${p => p.theme.c.light};
    }
`;

export const Description = styled.p`
    text-align: center;
    padding: 0 24px;
    font-weight: 300;
    font-size: 24px;
    color: ${p => p.theme.c.dark};
    ${p =>
        p.theme.md.only(css`
            font-size: 20px;
        `)}
    ${p =>
        p.theme.sm.max(css`
            font-size: 18px;
            padding: 0 16px;
        `)}
    ${p =>
        p.theme.xs(css`
            padding: 0;
            width: 240px;
            margin: 18px auto;
        `)}
`;

export const DonateButton = styled.button`
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    outline: none;
    margin: auto;
    display: block;
`;
